import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkArchiveAddress, IClientDetailsStore, IClientDetailsActions } from '../types';

const onArchiveAddress: IThunkArchiveAddress = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.archiveAddress(payload);

    const addresses = localState.addresses.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: true },
    );

    setClientDetails({ addresses });
  },
);

export default onArchiveAddress;
